import { render, staticRenderFns } from "./AppSeed.vue?vue&type=template&id=3a0a2f62&scoped=true&"
import script from "./AppSeed.vue?vue&type=script&lang=js&"
export * from "./AppSeed.vue?vue&type=script&lang=js&"
import style0 from "./AppSeed.vue?vue&type=style&index=0&id=3a0a2f62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0a2f62",
  null
  
)

export default component.exports